import connectToStores from 'alt-utils/lib/connectToStores'
import { SEOSettingsActions, ShopDetailsActions } from 'actions'
import { SEOSettingsStore, ShopDetailsStore } from 'stores'
import { StructuredDataPage } from 'pages'

@connectToStores
export default class StructuredDataContainer extends React.Component {
  static getStores() {
    return [
      SEOSettingsStore,
      ShopDetailsStore
    ]
  }

  static getPropsFromStores() {
    return {
      ...SEOSettingsStore.getState(),
      ...ShopDetailsStore.getState()
    }
  }

  componentWillMount() {
    if (!this.props.settings) {
      SEOSettingsActions.fetch()
    }

    if (!this.props.shopDetails) {
      ShopDetailsActions.fetch()
    }
  }

  render() {
    return (
      <StructuredDataPage
        settings={this.props.settings}
        fetching={this.props.fetching}
        shopDetails={this.props.shopDetails}
        noShopDetails={this.props.noShopDetails}
      />
    )
  }
}



// WEBPACK FOOTER //
// ./app/containers/plus/StructuredDataContainer.js